import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import SectionHeader from '../../../../atoms/SectionHeader';

export const HeaderSection = ({ sectionHeadings }) => (
  <div className="header-section">
    <div className="grid-container">
      <div className="grid-x grid-margin-x flex-container align-middle align-center">
        <div className="cell">
          <SectionHeader>
            <Heading extraClass="section__title" level={2}>
              {R.path(['header', 'heading'])(sectionHeadings)}
            </Heading>
          </SectionHeader>
        </div>
      </div>
    </div>
  </div>
);

HeaderSection.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
};
